import React from "react";
import { Col, Row, Card, CardBody, Label, Input } from "reactstrap";
import { FiDollarSign } from "react-icons/fi";
import { Tooltip } from "antd";
import { FaQuestionCircle } from "react-icons/fa";
import FormInput from "../../formInput/FormInput";

const Step3PricingStock = ({ newItem, setNewItem }) => {
    return (
        <Card className="border-0 shadow-sm mb-4 bg-light">
            <CardBody className="p-4">
                <div className="d-flex align-items-center gap-2 mb-4 pb-2 border-bottom">
                    <div className="bg-primary-soft p-2 rounded-3 text-primary">
                        <FiDollarSign size={16} />
                    </div>
                    <h6 className="fw-bold text-dark mb-0 text-uppercase tracking-wider" style={{ fontSize: '13px' }}>Stock & Pricing</h6>
                </div>
                <Row className="g-2">
            <Col md={2}>
                <FormInput
                    type={"number"}
                    label={"Quantity*"}
                    placeholder={""}
                    size={"large"}
                    value={newItem?.stc_quantity}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            stc_quantity: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={2}>
                <FormInput
                    type={"number"}
                    label={<span className="d-flex align-items-center gap-1">Markup <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Percentage markup over cost"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip></span>}
                    placeholder={""}
                    size={"large"}
                    value={newItem?.stc_markup}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            stc_markup: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={2}>
                <FormInput
                    type={"number"}
                    label={<span className="d-flex align-items-center gap-1">Map <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Minimum Advertised Price"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip></span>}
                    placeholder={""}
                    size={"large"}
                    value={newItem?.stc_map}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            stc_map: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={2}>
                <FormInput
                    type={"number"}
                    label={"Cost*"}
                    placeholder={""}
                    size={"large"}
                    value={newItem?.stc_cost}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            stc_cost: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={2}>
                <FormInput
                    type={"number"}
                    label={"Price*"}
                    placeholder={""}
                    size={"large"}
                    value={newItem?.price}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            price: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={2}>
                <FormInput
                    type={"number"}
                    label={<span className="d-flex align-items-center gap-1">MSRP <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Manufacturer's Suggested Retail Price"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip></span>}
                    placeholder={""}
                    size={"large"}
                    value={newItem?.stc_MSRP}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            stc_MSRP: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={4} className="mt-2">
                <FormInput
                    type={"text"}
                    label={"Shelf / Placement"}
                    placeholder={"e.g. Shelf A-1, Bin 4"}
                    size={"large"}
                    value={newItem?.shelf_location}
                    handleChange={(e) =>
                        setNewItem({
                            ...newItem,
                            shelf_location: e.target.value,
                        })
                    }
                />
            </Col>
            <Col md={4} className="mt-2">
                <Label className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '13px' }}>
                    Guest Price Visibility <Tooltip color="black" overlayInnerStyle={{ color: 'white' }} title="Control if guest users can see the price of this product"><FaQuestionCircle style={{ color: '#FFD700', cursor: 'pointer', border: '1px solid black', borderRadius: '50%', backgroundColor: 'black' }} /></Tooltip>
                </Label>
                <Input
                    type="select"
                    className="form-control-lg border-1 rounded-0 fs-14"
                    value={
                        newItem?.showPriceToGuests ? "show" :
                        newItem?.hidePriceFromGuests ? "hide" : "inherit"
                    }
                    onChange={(e) => {
                        const val = e.target.value;
                        setNewItem({
                            ...newItem,
                            showPriceToGuests: val === "show",
                            hidePriceFromGuests: val === "hide",
                        });
                    }}
                >
                    <option value="inherit">Inherit from Manufacturer</option>
                    <option value="show">Always Show Price</option>
                    <option value="hide">Force Hide Price</option>
                </Input>
            </Col>
        </Row>
            </CardBody>
        </Card>
    );
};

export default Step3PricingStock;
